import { memo } from 'react';
import cn from 'classnames';
import { unixToDate } from 'src/utils/date';
import { Element, LazyloadImage } from 'src/components';

import { IMatch } from '@zmedia/bm-soccer-ui/interface';
import { MATCH_STATUS } from '@zmedia/bm-soccer-ui/constants';

const MatchItem = ({ startTime, status, tournament, away, home }: IMatch) => {
    const isLive = status.id == MATCH_STATUS.LIVE;
    const notStarted =
        status.id == MATCH_STATUS.NOT_STARTED ||
        status.id == MATCH_STATUS.POSTPONED;
    const datetime = notStarted
        ? unixToDate(startTime, 'DD/MM/YYYY HH:mm')
        : unixToDate(startTime, 'DD/MM/YYYY');

    return (
        <Element
            className={cn(
                'match',
                'relative',
                'w-[180px] h-[70px]',
                'mr-[1px]',
                'bg-[#dee2e6]'
            )}
        >
            <Element
                className={cn(
                    'match__header',
                    'flex justify-between',
                    'h-[20px] leading-[1]',
                    'text-[1.2rem] text-white font-semibold',
                    'px-[3px]',
                    'overflow-hidden',
                    'bg-[#5f7d8b]'
                )}
            >
                <Element renderAs="span" className={'flex-shrink-0 mr-[2px]'}>
                    {datetime}
                </Element>
                <Element renderAs="span">{tournament?.name}</Element>
            </Element>
            <Element className={'relative'}>
                <Element
                    className={cn(
                        'flex items-center',
                        'w-full',
                        'text-[1.2rem] font-bold',
                        'px-[5px] py-[1px]'
                    )}
                >
                    <LazyloadImage
                        className="w-[10px] h-[10px] mr-[5px]"
                        src={home.team.logo}
                    />
                    <Element>{home.team.name}</Element>
                    <Element
                        className={cn(
                            'w-[10px]',
                            'text-[1.4rem] text-center',
                            'm-[0_0_auto_auto]',
                            {
                                ['text-[red] animate-[textblink_1s_linear_infinite]']:
                                    isLive,
                            }
                        )}
                    >
                        {notStarted ? '? ' : home.score}
                    </Element>
                </Element>
                <Element
                    className={cn(
                        'flex items-center',
                        'w-full',
                        'text-[1.2rem] font-bold',
                        'px-[5px] py-[1px]'
                    )}
                >
                    <LazyloadImage
                        className="w-[10px] h-[10px] mr-[5px]"
                        src={away.team.logo}
                    />
                    <Element>{away.team.name}</Element>
                    <Element
                        className={cn(
                            'w-[10px]',
                            'text-[1.4rem] text-center',
                            'm-[0_0_auto_auto]',
                            {
                                ['text-[red] animate-[textblink_1s_linear_infinite]']:
                                    isLive,
                            }
                        )}
                    >
                        {notStarted ? '? ' : away.score}
                    </Element>
                </Element>
            </Element>
        </Element>
    );
};

export default memo(MatchItem);
